<template>
  <v-container>

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">{{ $t('create_design_request.chosen_designer') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">{{ $t('create_design_request.customer_infor') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 3" step="3">{{
            $t('create_design_request.design_request_infor')
          }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 4" step="4">{{ $t('create_design_request.print_style_infor') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 5" step="5">{{ $t('create_design_request.form_style_infor') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 6" step="6">{{ $t('create_design_request.overview') }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container v-if="e1 === 1">
                        <span class="font-weight-black pb-2">
                            {{ $t('create_design_request.chosen_group') }}
                        </span>
            <v-row no-gutters>
              <v-col cols="12" sm="4">
                <v-autocomplete v-model="selectTeam" :items="teams" item-text="name" outlined return-object
                                dense></v-autocomplete>
              </v-col>
            </v-row>

            <span class="font-weight-black pb-2">{{ $t('create_design_request.chosen_designer') }}</span>

            <v-row no-gutters>
              <v-col cols="12" sm="2" v-for="design in designers" :key="design._id">
                <v-row align="center" justify="center">
                  <v-col class="12" sm="12">
                    <v-row class="mb-2" align="center" justify="center">
                      <v-avatar size="90" @click="selectedDesigner = design.user">
                        <img :class="selectedDesigner._id == design.user._id ? 'avataraBorder' : ''"
                             v-if="design.user.avatar" :src="baseImage + design.user.avatar"/>
                        <img :class="selectedDesigner._id == design.user._id ? 'avataraBorder' : ''" v-else
                             src='@/assets/avatar_default.png'/>
                      </v-avatar>
                    </v-row>
                    <v-row align="center" justify="center">
                      <span class="font-weight-black"> {{ design.user.fullname }} </span>
                    </v-row>
                    <v-row align="center" justify="center">
                      <span> {{ design.numberOfTodoDesignRequest }} TK/3 ngày </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="close">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkSelectDesigner" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-container align="center" v-if="e1 === 2">
            <v-row class="pl-5">
              <span
                  class="subTitleStyle">Bạn cần nhập số điện thoại hoặc facebook id để tìm kiếm thông tin khách hàng.</span>
            </v-row>
            <v-row align="start">
              <v-col cols="12" sm="5">
                <v-col>
                  <v-text-field v-model="customerInfor" v-bind:label="$t('create_design_request.phone_fb')" outlined
                                dense>
                    <v-tooltip slot="append-outer" bottom dark max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập số điện thoại hoặc facebook rồi bấm nút Tìm kiếm để tìm thông tin của khách hàng.
                                                Nếu không tồn tại khách hàng thì bấm tạo mới để thêm mới khách hàng</span>
                    </v-tooltip>
                  </v-text-field>
                </v-col>
              </v-col>
              <v-col>
                <v-col>
                  <v-btn color="primary" @click="getCustomerByPhone" width="120px" class="mr-5">
                    {{ $t('common.search') }}
                  </v-btn>

                  <v-btn color="primary" @click="showAddCustomer" width="120px" class="mr-5">
                    {{ $t('common.create') }}
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>

            <v-row align="start">
              <v-container align="center">
                <v-row align="start" justify="start">
                  <v-col v-for="item in customers" :key="item._id" :cols="6">
                    <v-card>
                      <v-card-title>
                        <span> {{ item.fullname }} </span>
                        <v-spacer></v-spacer>
                        <v-checkbox class="mb-5" v-model="customer" color="primary" :value="item"
                                    hide-details @click="chosenCustomer(item)">
                        </v-checkbox>
                      </v-card-title>

                      <v-card-text>
                        SĐT: {{ item.phone }}
                        <br/>
                        Facebook: {{ item.facebook }}
                        <br/>
                        Địa chỉ: {{ addressToString(item.defaultAddress) }}
                      </v-card-text>
                      <v-card-actions>

                        <v-spacer></v-spacer>

                        <!-- <v-btn icon> -->
                        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="editCustomer(item)">edit</v-icon>
                          </template>
                          <span>Chỉnh sửa thông tin khách hàng</span>
                        </v-tooltip>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>

          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkAddCustomer" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-container align="center" v-if="e1 === 3">
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="6" class="pr-5">
                <v-autocomplete v-model="selectOrderUnit" :items="orderUnits" item-text="displayString"
                                v-bind:label="$t('order_unit.title')" outlined return-object dense>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>{{ $t('tooltip_infor.oder_unit') }}</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="pl-5">
                <v-text-field v-model="requestTitle" :rules="stringRules"
                              v-bind:label="$t('design_manager.design_title')" outlined dense>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>Nhập tên yêu cầu thiết kế</span>
                  </v-tooltip>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" class="pr-5">
                <v-autocomplete v-model="selectCutomerType" :items="customerTypes" item-text="name"
                                v-bind:label="$t('design_item.customer_type')" outlined return-object dense>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>Chọn phân loại khách hàng</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="pl-5">
                <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                                v-bind:label="$t('profile.province')" outlined return-object dense>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>{{ $t('tooltip_infor.select_province') }}</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="pr-5">
                <v-numeric-field v-model="totalEstimate" v-bind:label="$t('design_item.total')" outlined dense>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>Nhập số lượng đặt hàng dự kiến</span>
                  </v-tooltip>
                </v-numeric-field>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkAddInforDesign" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-container align="center" v-if="e1 === 4">
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="8">

                <v-col>
                  <span class="header-title"> {{ $t('design_item.front_side') }} </span>
                </v-col>

                <v-col>
                  <vue-editor v-model="front.content" :editorOptions="editorOptions"
                              :placeholder="$t('design_item.front_side_content')">
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập nội dung mô tả mặt trước</span>
                    </v-tooltip>
                  </vue-editor>
                </v-col>

                <v-col>
                  <v-autocomplete v-model="front.printStyle" :items="printStyles" item-text="name"
                                  v-bind:label="$t('design_item.printStyle')" outlined return-object dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn kiểu in cho mặt trước</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col>
                  <v-textarea v-model="front.note" v-bind:label="$t('design_item.note')" outlined required dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú mô tả cho mặt trước</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>
              </v-col>

              <v-col cols="12" sm="4">
                <v-col>
                  <upload-dialog @uploadFileSuccess="uploadFrontSuccess"></upload-dialog>
                </v-col>

                <v-col>
                  <v-card class="mx-auto">
                    <v-card-text>
                      <v-container align="center">
                        <v-row align="start" v-for="file in frontUploadedFiles" :key="file.id">
                          <v-col cols="12" sm="10">
                            <a :href="baseAttach + file.id" target="_blank">
                              {{ file.filename }}
                            </a>
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-icon @click='deleteFrontImage(file)'> delete</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="8">
                <v-col>
                  <span class="header-title">{{ $t('design_item.behind') }}</span>
                </v-col>

                <v-col>
                  <vue-editor v-model="behind.content" :editorOptions="editorOptions"
                              :placeholder="$t('design_item.behind_content')">
                  </vue-editor>
                </v-col>

                <v-col>
                  <v-autocomplete v-model="behind.printStyle" :items="printStyles" item-text="name"
                                  v-bind:label="$t('design_item.printStyle')" outlined return-object dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn kiểu in cho mặt sau</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col>
                  <v-textarea v-model="behind.note" v-bind:label="$t('design_item.note')" outlined required dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú mô tả cho mặt sau</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

              </v-col>

              <v-col cols="12" sm="4">
                <v-col>
                  <upload-dialog @uploadFileSuccess="uploadBehindSuccess"></upload-dialog>
                </v-col>

                <v-col>
                  <v-card class="mx-auto">
                    <v-card-text>
                      <v-container align="center">
                        <v-row align="start" v-for="file in behindUploadedFiles" :key="file.id">
                          <v-col cols="12" sm="10">
                            <a :href="baseAttach + file.id" target="_blank">
                              {{ file.filename }}
                            </a>
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-icon @click='deleteBehindImage(file)'> delete</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="8">
                <v-col>
                  <span class="header-title">{{ $t('design_item.arm') }}</span>
                </v-col>

                <v-col>
                  <vue-editor v-model="arm.content" :editorOptions="editorOptions"
                              :placeholder="$t('design_item.arm_content')">
                  </vue-editor>
                </v-col>

                <v-col>
                  <v-autocomplete v-model="arm.printStyle" :items="printStyles" item-text="name"
                                  v-bind:label="$t('design_item.printStyle')" outlined return-object dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn kiểu in cho tay áo</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col>
                  <v-textarea v-model="arm.note" v-bind:label="$t('design_item.note')" outlined required dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú mô tả cho tay áo</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

              </v-col>

              <v-col cols="12" sm="4">
                <v-col>
                  <upload-dialog @uploadFileSuccess="uploadArmSuccess"></upload-dialog>
                </v-col>

                <v-col>
                  <v-card class="mx-auto">
                    <v-card-text>
                      <v-container align="center">
                        <v-row align="start" v-for="file in armUploadedFiles" :key="file.id">
                          <v-col cols="12" sm="10">
                            <a :href="baseAttach + file.id" target="_blank">
                              {{ file.filename }}
                            </a>
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-icon @click='deleteArmImage(file)'> delete</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkAddPrintStyle" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-container align="center" v-if="e1 === 5">
            <v-row align="center" justify="start">
              <v-col v-for="detail in requestDetails" :key="detail._id" :cols="6">

                <v-card>
                  <v-row no-gutters>
                    <v-col cols="12" sm="2">
                      <v-avatar color="grey" size="100%" max-height="150px" tile>
                        <v-img v-if="getImageOfMaterial(detail)" :src="getImageOfMaterial(detail)"
                               lazy-src='@/assets/noimage.png'/>
                        <v-img v-else src='@/assets/noimage.png'/>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" sm="10">
                      <v-card flat height="100%">
                        <v-card-text>
                          <div class="text-title"> {{ getFormStyleName(detail) }}</div>
                          <div class="text-title"> {{ createMaterialStyleString(detail) }}</div>
                          <div> {{ detail.note }}</div>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon>
                            <v-icon @click="editStyle(detail)">edit</v-icon>
                          </v-btn>

                          <v-btn icon>
                            <v-icon @click="deleteStyle(detail)">mdi-delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" width="200px" @click="addMoreStyle"> Thêm kiểu áo</v-btn>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="createRequestDesign" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="6">
          <v-container align="center" v-if="e1 === 6">
            <v-row align="start">
              <v-col cols="12" sm="6" v-if="customer">
                <v-row class="font-weight-black pb-2"> {{ $t('detail_request.customer_infor') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.fullname') }} {{ customer.fullname }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.phone') }} {{ customer.phone }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.address') }} {{
                    addressToString(customer.defaultAddress)
                  }}
                </v-row>

                <v-row class="pb-4"> {{ $t('detail_request.customer_type') }} {{ selectCutomerType.name }}</v-row>

                <v-row class="font-weight-black pb-2"> {{ $t('detail_request.email_content') }}</v-row>
                <!-- <v-row class="pb-1"> {{ $t('detail_request.number_estimate') }} {{ totalEstimate }} </v-row> -->
                <v-row class="pb-1"> {{ $t('detail_request.number_estimate') }} {{ thousandSeprator(totalEstimate) }}
                  chiếc
                </v-row>

                <v-row>Danh sách kiểu áo cần thiết kế:</v-row>
                <v-row v-for="(detail, index) in requestDetails" :key="detail._id">
                  <v-col cols="12" sm="1">
                    {{ index + 1 }}.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.form_style') }} {{ detail.formStyle.name }} <br/>
                    {{ $t('detail_request.material_style') }} {{ createMaterialStyleString(detail) }}
                  </v-col>
                </v-row>

                <v-row>Thông tin các mặt in:</v-row>
                <!-- <v-row> {{ $t('detail_request.font') }}
                    <div v-html='front.content'/> </v-row>
                <v-row v-if="front.printStyle"> {{ $t('detail_request.print_style') }} {{ front.printStyle.name }} </v-row>
                <v-row class="pb-2"> {{ $t('detail_request.note') }} {{ front.note }} </v-row> -->
                <v-row>
                  <v-col cols="12" sm="1">
                    1.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.font') }}
                    <div v-html='front.content'/>
                    <div v-if="front.printStyle">{{ $t('detail_request.print_style') }} {{
                        front.printStyle.name
                      }}
                    </div>
                    <div> {{ $t('detail_request.note') }} {{ front.note }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="1">
                    2.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.behind') }}
                    <div v-html='behind.content'/>
                    <div v-if="behind.printStyle">{{ $t('detail_request.print_style') }} {{
                        behind.printStyle.name
                      }}
                    </div>
                    <div> {{ $t('detail_request.note') }} {{ behind.note }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="1">
                    3.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.arm') }}
                    <div v-html='arm.content'/>
                    <div v-if="arm.printStyle">{{ $t('detail_request.print_style') }} {{ arm.printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ arm.note }}</div>
                  </v-col>
                </v-row>

                <!-- <v-row> {{ $t('detail_request.behind') }}
                    <div v-html='behind.content'/></v-row>
                <v-row v-if="behind.printStyle"> {{ $t('detail_request.print_style') }} {{ behind.printStyle.name}} </v-row>
                <v-row class="pb-2"> {{ $t('detail_request.note') }} {{ behind.note }} </v-row>


                <v-row> {{ $t('detail_request.arm') }}
                    <div v-html='arm.content'/> </v-row>
                <v-row v-if="arm.printStyle"> {{ $t('detail_request.print_style') }} {{arm.printStyle.name}} </v-row>
                <v-row class="pb-4"> {{ $t('detail_request.note') }} {{ arm.note }} </v-row> -->
              </v-col>

              <v-col cols="12" sm="6">
                <v-card>
                  <v-card-title> {{ $t('detail_request.image') }}</v-card-title>
                  <v-card-text>
                    <v-container align="center" justify="center">
                      <v-row align="center">
                        <v-col cols="12">
                          <span> {{ $t('design_item.front_side') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in frontUploadedFiles" :key="file.id">
                          <a :href="baseAttach + file.id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <span> {{ $t('design_item.behind') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in behindUploadedFiles" :key="file.id">
                          <a :href="baseAttach + file.id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <span> {{ $t('design_item.arm') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in armUploadedFiles" :key="file.id">
                          <a :href="baseAttach + file.id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="createNew">{{ $t('common.create') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="close" width="120px" class="mr-5">
              {{ $t('common.done') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialogAddStyle" persistent max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">Thêm kiểu áo và vật liệu</span>
        </v-card-title>

        <v-card-text>
          <v-container align="center">
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8">
                <v-autocomplete v-model="selectFormStyle" :items="formStyles" item-text="name"
                                v-bind:label="$t('manufacture_item.form_style')" outlined return-object>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>Chọn kiểu áo để thiết kế và sản xuất</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="8">
                <v-autocomplete v-model="selectMaterial" :items="materialStyles" item-text="displayString"
                                v-bind:label="$t('manufacture_item.material_style')" outlined return-object>
                  <!-- <template v-slot:selection="materialStyles">
                      {{ createMaterialStyleStringDefault(materialStyles.item) }}
                  </template>  -->

                  <!-- <template v-slot:item="materialStyles">
                      {{ createMaterialStyleStringDefault(materialStyles.item) }}
                  </template> -->
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>Chọn nguyên vật liệu để sản xuất áo</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="8">
                <v-text-field v-model="editedRequestDetails.note" v-bind:label="$t('design_item.note')" outlined>
                  <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">info</v-icon>
                    </template>
                    <span>Nhập ghi chú mô tả cho sản phẩm</span>
                  </v-tooltip>
                </v-text-field>
              </v-col>

              <!-- <v-col cols="12" sm="8">
                  <v-btn color="primary" @click="addStyle" width="200px" class="mr-5">{{ $t('common.save') }} </v-btn>

                  <v-btn color="primary" @click="closeAddStyle" width="200px">{{ $t('common.cancel') }} </v-btn>
              </v-col> -->
            </v-row>

          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="closeAddStyle">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="addStyle" width="120px" class="mr-5">
              {{ $t('common.save') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <customer-dialog :showDialog="dialogAddCustomer" :editedItem="customer" :editedIndex="editedCustomerIndex"
                     @closeDialog="closeDialog" @updateCustomer="updateCustomer" v-if="customer">
    </customer-dialog>

    <v-overlay :value="overlay" :z-index="0">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
//   import ImageInput from '@/components/ImageInput.vue';
import moment from 'moment';
import VNumericField from "@/components/VNumericField";
import UploadDialog from "@/components/UploadDialog";
// import AddAddressDialog from "@/components/AddAddressDialog";
import CustomerDialog from "@/components/CustomerDialog";
// Basic Use - Covers most scenarios
import {VueEditor} from "vue2-editor";
// import FileUpload from 'vue-upload-component';

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    overlay: true,
    isShow: false,
    e1: 1,
    e2: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    selectedDesigner: {},
    customer: null,
    customers: [],

    customerTypes: [],
    selectCutomerType: {},
    selectCustomer: {},

    selectOrderUnit: null,
    orderUnits: [],

    customerInfor: '',
    requestTitle: '',

    totalEstimate: 0,
    search: '',
    dialog: false,
    dialogAddCustomer: false,
    selectTeam: {},
    selectFormStyle: null,
    selectMaterial: null,
    formStyles: [],
    printStyles: [],
    materialStyles: [],
    desserts: [],
    teams: [],
    editedIndex: -1,
    editedCustomerIndex: -1,

    editedItem: {},
    defaultItem: {},
    designers: [],
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],
    phoneRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
    ],
    emailRules: [
      v => !!v || i18n.t('validate.email_require'),
      v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
    ],
    addressRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 2) || i18n.t('validate.address_invalid'),
    ],

    requestDetails: [],
    editedRequestDetails: {},
    dialogAddStyle: false,

    front: {},
    behind: {},
    arm: {},

    frontImage: null,
    behindImage: null,
    armImage: null,

    date: '',
    modal: false,

    editedAddressIndex: -1,
    editedAddress: {},

    isCustomerEdited: false,

    files: [],
    frontUploadedFiles: [],
    behindUploadedFiles: [],
    armUploadedFiles: [],

    selectProvince: null,
    provinces: [],

    editedStyleIndex: -1,

    editorOptions: {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{'script': 'sub'}, {'script': 'super'}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'direction': 'rtl'}],
          [{'size': ['small', false, 'large', 'huge']}],
          [{'color': []}, {'background': []}],

          [{'header': [1, 2, 3, 4, 5, 6]}],
          [{'font': []}],

          [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
          ['link']
        ],
      }
    },

    indexSideImage: 0, //0: front, 1:behind, 2:arm
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    },
  },

  components: {
    VNumericField: VNumericField,
    VueEditor: VueEditor,
    UploadDialog: UploadDialog,
    // AddAddressDialog: AddAddressDialog
    CustomerDialog: CustomerDialog
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    selectTeam(val) {
      this.selectedDesigner = {};
      this.getDesignByContext(val);
    },
    dialogAddStyle(val) {
      val || this.closeAddStyle()
    }
  },

  async created() {
    await Promise.all([
      this.getProvince(),
      this.getAllTeamDesigner(),
      this.getAllFormStyles(),
      this.getMaterialStyle(),
      this.getCustomerType(),
      this.getPrintStyles(),
      this.getOrderUnits()
    ]);
  },

  methods: {
    initialize() {
    },

    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    closeDialog(value) {
      this.dialogAddCustomer = value
      this.customer = null;
    },

    updateCustomer(value) {
      this.customer = value;
      if (this.editedCustomerIndex > -1) {
        Object.assign(this.customers[this.editedCustomerIndex], value);
      } else {
        this.customers = [];
        this.customers.push(value);
      }
    },

    showAddCustomer() {
      this.customer = {};
      // this.customers = [];
      // this.isShow = false;
      this.editedCustomerIndex = -1;
      this.dialogAddCustomer = true;
    },

    editCustomer(customer) {
      this.editedCustomerIndex = this.customers.indexOf(customer);
      this.customer = customer;
      this.dialogAddCustomer = true;
    },


    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close() {
      this.$router.push('designRequestManagement');
      this.e1 = 1;
    },

    back() {
      if (this.e1 > 1) {
        this.e1 = this.e1 - 1;
      }
    },

    async getAllTeamDesigner() {
      try {
        const response = await this.$http.get('/context/parentType/2?level=2');
        if (response.data && response.data.success) {
          let contextArr = response.data.data;
          contextArr = contextArr.filter(item => item._id !== String(process.env.VUE_APP_ID_CONTEXT_FREELANCER));
          this.teams = contextArr;

          if (this.teams.length > 0) {
            this.selectTeam = this.teams[0];
          }

        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getAllFormStyles() {
      try {
        const response = await this.$http.get('/formStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.formStyles = contextArr;

          if (this.formStyles.length > 0) {
            this.selectFormStyle = this.formStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getMaterialStyle() {
      try {
        const response = await this.$http.get('/materialStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.materialStyles = contextArr;

          if (this.materialStyles.length > 0) {
            this.materialStyles.forEach(item => {
              item.displayString = this.createMaterialStyleStringDefault(item);
            });

            this.selectMaterial = this.materialStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getDesignByContext(context) {
      const currentDate = moment(String(new Date())).format("DD/MM/YYYY");

      try {
        // ponse = await this.$http.get('/api/designRequest/contextStatsByUsers/' + context._id + "?from=" + from + "&to=" + to);
        const response = await this.$http.get('/api/designRequest/contextStatsByUsersDateBack/' + context._id + "?dateBack=" + currentDate);
        this.overlay = false;
        if (response.data && response.data.success) {
          this.designers = response.data.data;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getCustomerByPhone() {
      this.addresses = [];
      this.customer = {};
      this.customers = [];
      this.isShow = false;
      this.selectedAddressDefault = {};
      const self = this;
      // this.selectDistrict = this.districts[0];

      if (this.customerInfor.trim().length == 0) {
        alert('Chưa nhập thông tin');
        return;
      }
      try {
        // const response =  await self.$http.get('/customer/phone/' + self.customerPhone);
        const response = await self.$http.get(process.env.VUE_APP_CUSTOMER_QUERY_API + self.customerInfor.trim());

        if (response.data && response.data.success) {
          if (response.data.data.length == 0) {
            alert('Không có khách hàng nào')
          } else {
            this.customers = response.data.data;
          }

        } else if (response.data && !response.data.success) {
          alert(response.data.message);
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getCustomerType() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_CUSTOMER_TYPE_API);
        if (response.data && response.data.success) {
          this.customerTypes = response.data.data;
          if (this.customerTypes.length > 0) {
            this.selectCutomerType = this.customerTypes[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getPrintStyles() {
      try {
        const response = await this.$http.get('/printStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.printStyles = contextArr;
          if (this.printStyles.length > 0) {
            this.selectPrintStyle = this.printStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    createHeaderStyle(detail) {
      return detail.formStyle.name + " - " + this.createMaterialStyleString(detail);
    },

    getFormStyleName(detail) {
      return detail.formStyle.name;
    },

    getImageOfMaterial(detail) {
      if (detail.materialStyle.images.length > 0) {
        return this.baseImage + detail.materialStyle.images[0];
      }
      return '';
    },

    addMoreStyle() {
      this.dialogAddStyle = true;
    },

    addStyle() {
      this.editedRequestDetails.formStyle = this.selectFormStyle;
      this.editedRequestDetails.materialStyle = this.selectMaterial;

      if (this.editedStyleIndex > -1) {
        Object.assign(this.requestDetails[this.editedStyleIndex], this.editedRequestDetails);
      } else {
        this.requestDetails.push(this.editedRequestDetails);
      }

      this.dialogAddStyle = false;
      this.editedRequestDetails = {};
      this.editedStyleIndex = -1
    },

    closeAddStyle() {
      this.dialogAddStyle = false;
      this.editedStyleIndex = -1;
    },

    editStyle(detail) {
      // this.editedRequestDetails.formStyle = this.selectFormStyle;
      // this.editedRequestDetails.materialStyle = this.selectMaterial;

      // Object.assign(detail, this.editedRequestDetails);
      this.editedStyleIndex = this.requestDetails.indexOf(detail);
      this.editedRequestDetails = detail;
      this.selectFormStyle = this.editedRequestDetails.formStyle;
      this.selectMaterial = this.editedRequestDetails.materialStyle;
      // this.editedRequestDetails = {};
      this.dialogAddStyle = true;
    },

    deleteStyle(detail) {
      const agree = confirm(i18n.t('common.confirm_delete'))
      if (agree) {
        const index = this.requestDetails.indexOf(detail);
        this.requestDetails.splice(index, 1);
      }
    },

    createNew() {
      //gan lai cac bien va ve e1
      this.selectTeam = this.teams[0];

      this.addresses = [];
      this.customer = {};
      this.isShow = false;
      this.selectedAddressDefault = {};

      this.requestTitle = '';
      this.selectCutomerType = this.customerTypes[0];
      this.totalEstimate = 0;

      this.front = {};
      this.behind = {};
      this.arm = {};

      this.requestDetails = [];

      this.e1 = 1;
    },

    checkSelectDesigner() {
      if (!this.selectedDesigner._id) {
        alert(i18n.t('design_item.warning_designer'));
      } else {
        this.e1 = 2;
      }

      // this.e1 = 5;
    },

    checkAddCustomer() {
      if (!this.customer || !this.customer._id) {
        alert(i18n.t('design_item.warning_customer'));
      } else {
        this.e1 = 3;
      }
      // console.log(this.customer);
      // this.e1 = 3;
    },

    checkAddPrintStyle() {
      // if (!this.front.content || !this.behind.content || !this.arm.content) {
      //     alert("Chưa nhập đủ nội dung in");
      //     return;
      // }
      if (!this.front.printStyle || !this.behind.printStyle || !this.arm.printStyle) {
        alert("Chưa chọn kiểu in");
        return;
      }

      // if (!Array.isArray(this.frontUploadedFiles) || !Array.isArray(this.behindUploadedFiles) ||
      //  !Array.isArray(this.armUploadedFiles)) {
      //     alert("Chưa nhập đủ ảnh minh họa");
      //     return;
      // }

      this.e1 = 5;
    },

    async uploadImage(data) {
      if (data.formData != null) {
        const response = await this.$httpUpload.post("/uploadImg/", data.formData);
        if (response.data && response.data.id) {
          data.id = response.data.id;
        } else if (response.data && !response.data.success) {
          alert(response.data.message);
        } else {
          alert(i18n.t('validate.request_error'));
        }
      }
    },

    async createRequestDesign() {
      if (this.requestDetails.length == 0) {
        alert('Chưa chọn kiểu áo và chất liệu');
        return;
      }

      const agree = confirm(i18n.t('common.confirm_create_design'));
      if (!agree) {
        return;
      }

      let frontImageIds = [];
      this.frontUploadedFiles.forEach(item => {
        frontImageIds.push(item.id);
      });

      let behindImageIds = [];
      this.behindUploadedFiles.forEach(item => {
        behindImageIds.push(item.id);
      });

      let armImageIds = [];
      this.armUploadedFiles.forEach(item => {
        armImageIds.push(item.id);
      });

      let requestBody = {
        designer: this.selectedDesigner._id,

        customerType: this.selectCutomerType,
        requestTitle: this.requestTitle,
        expected_number: this.totalEstimate,
        front_content: this.front.content,
        front_images: frontImageIds,
        front_printStyle: this.front.printStyle,
        front_note: this.front.note,

        behind_content: this.behind.content,
        behind_images: behindImageIds,
        behind_printStyle: this.behind.printStyle,
        behind_note: this.behind.note,

        arm_content: this.arm.content,
        arm_images: armImageIds,
        arm_printStyle: this.arm.printStyle,
        arm_note: this.arm.note,
        vtProvince: this.selectProvince._id,
        orderUnit: this.selectOrderUnit,

        request_details: this.requestDetails
      }

      if (this.customer) {
        requestBody = {
          ...requestBody,
          customer: this.customer._id,
        }
      }

      console.log(requestBody);

      try {
        const response = await this.$http.post('/designRequest', requestBody);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.success'),
            text: "",
            type: "success"
          }).then(() => {
            this.e1 = 6;
          });
        } else if (response.data && !response.data.success) {
          alert(response.data.message);
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
        alert(i18n.t('validate.request_error'));
      }
    },

    checkAddInforDesign() {
      if (!this.selectOrderUnit) {
        alert('Chưa chọn Đơn vị đặt hàng');
        return;
      }

      if (this.requestTitle.length == 0) {
        alert('Chưa nhập tên yêu cầu');
        return;
      }

      if (!this.totalEstimate || this.totalEstimate.length === 0) {
        alert('Chưa nhập số lượng dự kiến');
        return;
      }

      if (!this.selectProvince) {
        alert('Chưa chọn Tỉnh/TP');
        return;
      }

      this.e1 = 4;
    },

    createMaterialStyleString(detail) {
      if (!detail.materialStyle) {
        return '--';
      }
      return detail.materialStyle.material.name + " - " + detail.materialStyle.color_name + ' (' + detail.materialStyle.code + ')';
    },

    createMaterialStyleStringDefault(detail) {
      if (!detail) {
        return '--';
      }
      return detail.code + ' (' + detail.material.name + " - " + detail.color_name + ')';
    },

    chosenCustomer(customer) {
      this.customer = customer;
    },

    deleteFrontImage(file) {
      if (Array.isArray(this.frontUploadedFiles) && this.frontUploadedFiles.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          this.frontUploadedFiles.splice(this.frontUploadedFiles.indexOf(file), 1);
        }
      }
    },

    uploadArmSuccess(value) {
      this.armUploadedFiles = this.armUploadedFiles.concat(value);
    },

    uploadBehindSuccess(value) {
      this.behindUploadedFiles = this.behindUploadedFiles.concat(value);
    },

    uploadFrontSuccess(value) {
      this.frontUploadedFiles = this.frontUploadedFiles.concat(value);
    },

    deleteBehindImage(file) {
      if (Array.isArray(this.behindUploadedFiles) && this.behindUploadedFiles.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          this.behindUploadedFiles.splice(this.behindUploadedFiles.indexOf(file), 1);
        }
      }
    },

    deleteArmImage(file) {
      if (Array.isArray(this.armUploadedFiles) && this.armUploadedFiles.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          this.armUploadedFiles.splice(this.armUploadedFiles.indexOf(file), 1);

        }
      }
    },

    thousandSeprator(amount) {
      if (!amount) {
        return '0';
      }

      if (amount !== '' || amount !== 0 || amount !== '0' || amount !== null) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return amount;
      }
    },

    addressToString(detail) {
      if (detail && detail.fullDetail) {
        return detail.fullDetail;
      } else {
        return '';
      }
    },

    async getProvince() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
        if (response.data && response.data.success) {
          this.provinces = response.data.data;
          this.selectProvince = this.provinces[0];
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getOrderUnits() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_ORDER_UNIT_API);
        if (response.data && response.data.success) {
          this.orderUnits = [].concat(response.data.data);
          if (this.orderUnits.length > 0) {
            this.orderUnits.forEach(item => {
              item.displayString = this.createOrderUnitString(item);
            });
          }

          // if (this.orderUnits.length > 0) {
          //     this.selectOrderUnit = this.orderUnits[0];
          // }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    createOrderUnitString(item) {
      if (!item) {
        return '--';
      }
      return item.name + ' - ' + item.vtProvince.province_name + (item.description ? (' (' + item.description + ')') : '');
    }
  },
}
</script>

<style scoped>
.avataraBorder {
  border: 4px solid #F08942
}
</style>